import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from '@xstyled/styled-components';
import { Pagination, Table } from 'antd';
import { useMemo } from 'react';
import { renderColumns } from './homework-assignment-columns';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTable = styled(Table)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-table-container table {\n    & > thead > tr > th {\n      height: 48px;\n      padding: 8px 12px;\n      text-align: center;\n      vertical-align: middle;\n    }\n    & > tbody > tr > td {\n      cursor: pointer;\n    }\n  }\n  .ant-table-thead > tr > th {\n    background-color: ", ";\n  }\n  margin-bottom: 20px;\n"])), styleVariables.colors.blue1);
var StyledPagination = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 100px;\n"])));
export var HomeworkAssignmentAttendeeTable = function HomeworkAssignmentAttendeeTable(props) {
  var pagination = props.pagination,
      attendees = props.attendees,
      label = props.label,
      isLoading = props.isLoading,
      onOpenAttendeeSubmission = props.onOpenAttendeeSubmission,
      assignment = props.assignment;
  var columns = useMemo(function () {
    return renderColumns({
      label: label,
      assignment: assignment,
      onOpenAttendeeSubmission: onOpenAttendeeSubmission
    });
  }, [label, assignment, onOpenAttendeeSubmission]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledTable, {
      loading: isLoading,
      bordered: true,
      dataSource: attendees,
      columns: columns,
      pagination: false,
      locale: {
        emptyText: label.emptyText
      }
    }), /*#__PURE__*/_jsx(StyledPagination, {
      children: pagination && /*#__PURE__*/_jsx(Pagination, {})
    })]
  });
};